import { toast } from "react-toastify";
import { SessionRefreshNotification } from "../ui/SessionRefreshNotification";
import {
  keycloak,
  MIN_SECONDS_BEFORE_REFRESH_KEYCLOAK_TOKEN,
  SessionExpiredError,
} from "@/entities/keycloak";
import { setContext } from "@apollo/client/link/context";

export { MIN_SECONDS_BEFORE_REFRESH_KEYCLOAK_TOKEN };

const TOAST_ID_SESSION_REFRESH = "TOAST_ID_SESSION_REFRESH";

export const displaySessionRefreshNotification = () =>
  toast.error(SessionRefreshNotification(), {
    autoClose: false,
    closeOnClick: false,
    closeButton: false,
    toastId: TOAST_ID_SESSION_REFRESH,
  });

// Update token if expired before every request
export const keycloakContextLink = setContext(async (_req, ctx) => {
  try {
    await keycloak.updateToken(MIN_SECONDS_BEFORE_REFRESH_KEYCLOAK_TOKEN);
  } catch {
    // The session is gone, so the request would reach the backend with a dead
    // token and be rejected. Stop it here instead: the user already has the
    // notification above, and sending it only adds a backend error and a
    // second, less useful toast.
    displaySessionRefreshNotification();
    throw new SessionExpiredError();
  }
  return ctx;
});
